import { Box, TabPanels, Tabs } from "@chakra-ui/react";
import { motion } from "framer-motion";
import {
  ContentTab,
  TabCustom,
  TabListCustom,
  TabPanelCustom,
  TabTitle,
} from "pages/Contract/styles";
import Detran from "./components/Detran";
import PaymentGuide from "./components/PaymentGuide";
import Registration from "./components/Registration";

const Fee = () => {
  return (
    <Tabs
      isLazy
      style={{
        background: "transparent",
      }}
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      height="100%"
    >
      <TabListCustom
        style={{
          background: "transparent",
        }}
      >
        <ContentTab>
          <TabCustom>Gestão de Taxa Detran Pré Pago</TabCustom>
          <TabCustom>Gestão de Tabela de Preço</TabCustom>
          <TabCustom>Gestão de Tabela de Taxa Detran</TabCustom>
          <TabCustom>Geração de Remessa de Taxas </TabCustom>
        </ContentTab>
      </TabListCustom>
      <TabTitle
        pt={4}
        style={{
          background: "transparent",
        }}
      ></TabTitle>
      <TabPanels>
        <TabPanelCustom
          style={{
            background: "transparent",
          }}
        >
          <Box>
            <Detran />
          </Box>
        </TabPanelCustom>
        <TabPanelCustom
          style={{
            background: "transparent",
          }}
        >
          <Registration mode="price" />
        </TabPanelCustom>
        <TabPanelCustom
          style={{
            background: "transparent",
          }}
        >
          <Registration mode="tax" />
        </TabPanelCustom>
        <TabPanelCustom>
          <Box>
            <PaymentGuide />
          </Box>
        </TabPanelCustom>
      </TabPanels>
    </Tabs>
  );
};

export default Fee;
